let metaData = {
  entitler: {
    selectedValues: undefined,
    dataSet: undefined,
    search: {
      value: undefined,
      errors: {
        NO_SEARCH_RESULTS: false,
        SEARCH_FIELD_MINLENGTH_ERROR: false,
        SEARCH_FIELD_MAXLENGTH_ERROR: false
      }
    }
  },
  customers: {
    dataSet: undefined,
    search: {
      value: undefined,
      errors: {
        NO_SEARCH_RESULTS: false,
        SEARCH_FIELD_MINLENGTH_ERROR: false,
        SEARCH_FIELD_MAXLENGTH_ERROR: false
      }
    }
  }
};

export default metaData;


// WEBPACK FOOTER //
// ./app/models/metaData.js